import Button from 'components/base/Button';
import AvatarUpload from 'components/common/AvatarUpload';
import avatar from 'assets/img/team/150x150/avatar.webp';
import { Col, FloatingLabel, Form, Row, Toast, ToastContainer } from 'react-bootstrap';
import ContactInformationForm from './components/ContactInformationForm';
import { useAuth } from 'providers/AuthProvider'
import { useState, FormEvent } from 'react';
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useNavigate } from 'react-router-dom';

const AddContact = () => {

    const navigate = useNavigate();
    const auth = useAuth();

    // State to store the form data from all child components
    const [formData, setFormData] = useState<any>({ 'contactForm': '', 'notes': '', 'image': null });
    // State to control Toast messages
    const [show, setShow] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const onChangeContactImage = (image: File | null) => {
        if (image) {
            //console.log(image);
            setFormData({ ...formData, ['image']: image });
        }
    };

    // Function to handle input changes
    const handleNotesInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Function to handle form data update from child components
    const updateFormData = (name: string, data: any) => {
        setFormData({ ...formData, [name]: data });
    };



    const handleSumbit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        //console.log(formData);
        const form = new FormData();
        form.append('contactForm', JSON.stringify(formData['contactForm']));
        form.append('notes', formData['notes']);
        form.append('file', formData['image']);

        try {
            const response = await apiClient.post(
                '/v1/contacts', form,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',

                    }
                }
            );
            setToastMessage(response.data['message'])
            setShow(true);
        } catch (error) {
            console.error('Request failed:', error);
        }

    };

    return (
        <div className="mb-9">
            <div>
                <ToastContainer className="p-3" position='top-center'>
                    <Toast onClose={() => { setShow(false); navigate(-1); }} show={show} delay={3000} autohide>
                        <Toast.Body className=''>{toastMessage}</Toast.Body>
                    </Toast>
                </ToastContainer>
            </div>
            <Form onSubmit={handleSumbit}>
                <div className="border-bottom mb-7 mx-n3 px-2 mx-lg-n6 px-lg-6">
                    <Row>
                        <Col xl={12}>
                            <div className="d-sm-flex justify-content-between">
                                <h2 className="mb-4">Create a new contact</h2>
                                <div className="d-flex mb-3">
                                    <Button variant="phoenix-primary" className="me-2 px-6" onClick={() => navigate(-1)} >
                                        Back
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <Row>
                    <Col sm={3} md={3} >
                        <div className="d-flex align-items-end position-relative mb-7">
                            <AvatarUpload src={formData['image'] ? formData['image'] : avatar} size="5xl" onChange={onChangeContactImage} />
                        </div>
                    </Col>
                    <Col sm={9} md={9} >
                        <ContactInformationForm onUpdate={data => updateFormData('contactForm', data)} className="mb-6" />
                    </Col>
                </Row><Row>
                    <Col>


                        <h4 className="mb-3">Notes about contact</h4>
                        <FloatingLabel
                            controlId="contact-description"
                            label="Contact notes"
                        >
                            <Form.Control
                                as="textarea"
                                style={{ height: '128px' }}
                                type="text"
                                placeholder="Contact notes"
                                name='notes' value={formData.notes} onChange={handleNotesInputChange} />
                        </FloatingLabel>
                        <div className="text-end">
                            <Button type="submit" variant="primary" className='mt-2'>Save contact</Button>
                        </div>

                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default AddContact;
